export const REPORT_TYPE_LABELS = {
  unsafe_meetup: 'Unsafe meetup',
  robbery_concern: 'Robbery concern',
  blackmail: 'Blackmail / extortion',
  threat_violence: 'Threat / violence',
  underage_concern: 'Underage concern',
  fake_profile: 'Fake profile',
  scam_fraud: 'Scam / fraud',
  catfish: 'Catfish',
  harassment: 'Harassment',
  hate_speech: 'Hate speech',
  spam: 'Spam',
  inappropriate_content: 'Inappropriate content',
  other: 'Other',
};

export function formatReportType(id) {
  if (!id) return 'Legacy report';
  return REPORT_TYPE_LABELS[id] || id.replace(/_/g, ' ');
}
